import { createContext, useContext, useState, useCallback } from 'react';

const FeedbackModalContext = createContext({
  isOpen: false,
  defaultType: 'bug',
  openFeedbackModal: () => {},
  closeFeedbackModal: () => {},
});

export function FeedbackModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [defaultType, setDefaultType] = useState('bug');

  const openFeedbackModal = useCallback((type = 'bug') => {
    setDefaultType(type === 'feature' ? 'feature' : 'bug');
    setIsOpen(true);
  }, []);

  const closeFeedbackModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <FeedbackModalContext.Provider
      value={{
        isOpen,
        defaultType,
        openFeedbackModal,
        closeFeedbackModal,
      }}
    >
      {children}
    </FeedbackModalContext.Provider>
  );
}

export function useFeedbackModal() {
  const context = useContext(FeedbackModalContext);
  if (!context) {
    return {
      isOpen: false,
      defaultType: 'bug',
      openFeedbackModal: () => {},
      closeFeedbackModal: () => {},
    };
  }
  return context;
}

export default FeedbackModalContext;
